<template>
    <div class="threejsContainer">
      <div class="containerTitle">1-15.透视和正交混合渲染（双场景，双相机，单渲染器）<button @click="intoScene">入场</button><button @click="outScene">出场</button></div>
      <div ref="container" class="containerBody"></div>
    </div>
  </template>
  
  <script>
  import * as THREE from 'three';
  import {generateScene} from '@/threejsEnv/scene.js';
  import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
  import {genPerspectiveCamera,genOrthographicCamera} from '@/threejsEnv/camera.js';
  import {genRenderer} from '@/threejsEnv/renderer.js';
  import gsap from 'gsap';
  
  export default {
    //设计思想是：正交相机有一个场景，透视相机有另一个场景，两个场景分别加入不同的物体
    //           渲染器分别对两个场景进行渲染。
    data() {
      return {
        perScene: null,
        orgScene: null,
        percamera: null,
        orgcamera: null,
        renderer: null,
        controls: null,
        currentMesh: null,
        progress: 0,
        cubeStep: 0.03,
        raycaster: null,
        mouse: null,
        cube: null,
        cube1: null,
        u_time: 0,
        window: {
          width: 0,
          height: 0
        },
        animationId: null
      };
    },
    mounted() {
      //初始化环境
      this.initEnv();
      //创建网格对象
      this.createMesh();
      this.animate();
      // 监听窗口大小变化
      window.addEventListener('resize', this.onWindowResize);
    },
    methods: {
      intoScene(){
        gsap.to(this.cube1.position, {
          x: 0,          // 目标x坐标
          duration: 1,   // 运动时长（秒）
          ease: "power2.out"  // 缓动类型（先快后慢，平滑停止）
        });
      },
      outScene(){
        gsap.to(this.cube1.position, {
          x: 9,
          duration: 1,
          ease: "power2.out"
        });
      },
      createMesh() {
        const material = new THREE.MeshBasicMaterial({ color: 0x00ff00, wireframe: false });
        const geometry = new THREE.BoxGeometry();
        this.cube = new THREE.Mesh(geometry, material);
        this.perScene.add(this.cube);

        const material2 = new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: false });
        this.cube1 = new THREE.Mesh(geometry, material2);
        this.orgScene.add(this.cube1);
      },
      animate() {
        this.animationId = requestAnimationFrame(this.animate);
        this.controls.update();
        this.u_time += 0.02;
        this.cube.position.x = Math.sin(this.u_time)*5.0;
        
        this.renderer.autoClear = false;
        this.renderer.setViewport(0, 0, this.window.width, this.window.height);
        this.renderer.render(this.perScene, this.percamera);

        this.renderer.render(this.orgScene, this.orgcamera);
      },
      initEnv(){
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        // 初始化场景
        this.perScene = generateScene();
        this.perScene.background = new THREE.Color(0xffffff);
  
        // 初始化相机
        this.percamera = genPerspectiveCamera(this.window);

        this.orgScene = new THREE.Scene();
        this.orgcamera = genOrthographicCamera(this.window);
        this.orgcamera.position.z = 3.0;
  
        // 初始化渲染器
        this.renderer = genRenderer(this.window);
        this.$refs.container.appendChild(this.renderer.domElement);
  
        // 添加轨道控制器
        this.controls = new OrbitControls(this.percamera, this.renderer.domElement);
        this.controls.enableDamping = true;
  
        // 创建光源
        const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
        this.perScene.add(ambientLight);
        
        const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
        directionalLight.position.set(10, 20, 15);
        this.perScene.add(directionalLight);

        this.raycaster = new THREE.Raycaster();
        this.mouse = new THREE.Vector2();
        window.addEventListener('click', this.onMouseClick);
  
        const gridHelper = new THREE.GridHelper(100, 100,
                                                0x666666,   // 中心轴线颜色（红色）
                                                0xcccccc    // 普通网格线颜色（绿色）
                                                ); // 10x10 网格
        this.perScene.add(gridHelper);
      },
      onMouseClick(event) {
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
        
        this.raycaster.setFromCamera(this.mouse, this.orgcamera);

        const intersects = this.raycaster.intersectObject(this.cube1);

        if (intersects.length > 0) {
            const randomColor = new THREE.Color(Math.random() * 0xffffff);
            // 点击后改变立方体颜色
            gsap.to(this.cube1.material.color, {
              r: randomColor.r,
            g: randomColor.g,
            b: randomColor.b,
              duration: 1,
              ease: "power2.out"
            });
        }
      },
      onWindowResize() {
        const width = this.$refs.container.clientWidth;
        const height = this.$refs.container.clientHeight;
  
        // 更新相机
        this.percamera.aspect = width / height;
        this.percamera.updateProjectionMatrix();
  
        // 更新渲染器
        this.renderer.setSize(width, height);
      }
    },
    beforeDestroy() {
      // 清理动画和事件监听
      cancelAnimationFrame(this.animationId);
      window.removeEventListener('resize', this.onWindowResize);
      
      // 释放资源
      if (this.currentMesh) {
        this.perScene.remove(this.currentMesh);
        this.currentMesh.geometry.dispose();
        this.currentMesh.material.dispose();
      }
      
      this.controls.dispose();
      this.renderer.dispose();
      this.renderer.domElement.remove();
    }
  };
  </script>
  
  <style>
  </style>
  